import { render, staticRenderFns } from "./AcountingSalesPurchases.vue?vue&type=template&id=7c49726a&scoped=true"
import script from "./AcountingSalesPurchases.vue?vue&type=script&lang=js"
export * from "./AcountingSalesPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c49726a",
  null
  
)

export default component.exports